import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazySelling = Loadable({
    loader: () => import("pages/Selling/index"),
    loading: () => <PageLoader />,
});

const LazySellingForm = Loadable({
    loader: () => import("pages/SellingForm/index"),
    loading: () => <PageLoader />,
});

function SellingRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazySelling />} />
            <Route path="/create" element={<LazySellingForm />} />
        </Routes>
    );
}

export default SellingRoute;
